import VuexPersistence from "vuex-persist";
import { createStore } from "vuex";
import auth from "./modules/auth";
import backoffice from "./modules/backoffice";
import claimDeclarations from "@/store/modules/claimDeclarations";
import claims from "@/store/modules/claims";
import iban from "@/store/modules/iban";
import claimQuotations from "@/store/modules/claimQuotations";
import claimInvoices from "@/store/modules/claimInvoices";
import contractDistributions from "@/store/modules/contractDistributions";
import insurers from "@/store/modules/insurers";
import merchantProfiles from "@/store/modules/merchantProfiles";
import notifications from "./modules/notifications";
import organizations from "@/store/modules/organizations";
import stores from "@/store/modules/stores";
import products from "@/store/modules/products";
import businessVerticals from "@/store/modules/businessVerticals";
import cancellations from "@/store/modules/cancellations";
import unfixeableClaimProducts from "@/store/modules/claims/unfixeableClaimProducts";
import complaints from "@/store/modules/complaints";
import invoices from "@/store/modules/invoices";
import storeOnboardingProgressions from "@/store/modules/storeOnboardingProgressions";
import sellers from "@/store/modules/sellers";
import claimDeductibles from "@/store/modules/claims/claimDeductibles";
import finalSettlements from "@/store/modules/claims/finalSettlements";
import discounts from "@/store/modules/discounts";
import challenges from "@/store/modules/challenges";
import insurerReportings from "@/store/modules/insurerReportings";
import planSales from "@/store/modules/planSales";
import matchedContracts from "@/store/modules/matchedContracts";
import storeEventNotes from "@/store/modules/storeEventNotes";
import leads from "@/store/modules/leads";
import mandates from "@/store/modules/mandates";
import analytics from "@/store/modules/analytics";
import billingEntities from "@/store/modules/billingEntities";
import aiAnalysisFeedbacks from "@/store/modules/aiAnalysisFeedbacks";
import emailLogs from "@/store/modules/emailLogs";
import thirdPartyActors from "@/store/modules/thirdPartyActors";
import estalyManagers from "@/store/modules/estalyManagers";
import cable from "@/store/modules/cable";

const vuexLocal = new VuexPersistence({
  key: "vuex_bo",
  storage: window.localStorage,
});

export default createStore({
  modules: {
    auth,
    backoffice,
    claimDeclarations,
    claims,
    iban,
    claimQuotations,
    claimInvoices,
    contractDistributions,
    insurers,
    merchantProfiles,
    notifications,
    organizations,
    planSales,
    stores,
    products,
    businessVerticals,
    cancellations,
    unfixeableClaimProducts,
    complaints,
    invoices,
    storeOnboardingProgressions,
    sellers,
    claimDeductibles,
    finalSettlements,
    discounts,
    challenges,
    insurerReportings,
    matchedContracts,
    storeEventNotes,
    leads,
    mandates,
    analytics,
    billingEntities,
    aiAnalysisFeedbacks,
    emailLogs,
    thirdPartyActors,
    estalyManagers,
    cable,
  },
  plugins: [vuexLocal.plugin],
});
